import React, { Component } from 'react';
import { Trans } from 'react-i18next';
import { QueryResult } from 'react-apollo';

import { GetGroupFollowersComponent, GetGroupFollowersDocument, Group, UserFeedFollow } from 'api';
import { QueryManager, ProfilesWidget } from 'components';

interface IProps {
  group: Group;
}

class Members extends Component<IProps> {
  renderList(props: QueryResult) {
    const { group } = this.props;
    const { data } = props;

    if (!data) {
      return null;
    }

    const { feedFollowing } = data;
    const { count, feed_follows } = feedFollowing;

    return (
      <ProfilesWidget
        maxResults={8}
        maxWidth={170}
        link={`/group/${group.id}/members`}
        results={feed_follows.map((feedFollow: UserFeedFollow) => feedFollow.followed_by_user)}
        title={<Trans i18nKey="components:xMember" count={count} />}
        refetchQueries={[
          { query: GetGroupFollowersDocument, variables: { id: group.id, limit: 8 } },
        ]}
      />
    );
  }

  render() {
    const { group } = this.props;

    return (
      <GetGroupFollowersComponent variables={{ id: group.id, limit: 10 }}>
        {props => (
          <QueryManager loader="widget" {...props}>
            {() => this.renderList(props)}
          </QueryManager>
        )}
      </GetGroupFollowersComponent>
    );
  }
}

export default Members;
